import React from 'react';
import { useTranslation } from '../../../../i18n';

export interface SaveTheAnimalsHostProps {
  themeTitle: string;
  animals: string[];
  roundEnded?: boolean;
}

/**
 * Host view during play: theme title = what to catch this round, plus emoji preview.
 * Pack title (Save the Party / Team / animals) is shown on the intro screen only.
 */
export const SaveTheAnimalsHost: React.FC<SaveTheAnimalsHostProps> = ({
  themeTitle,
  animals,
  roundEnded = false,
}) => {
  const { t } = useTranslation();

  if (roundEnded) return null;

  const previewEmojis = (animals ?? []).slice(0, 10).join(' ');

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1 1 auto',
        minHeight: 0,
        padding: '1rem',
        gap: '2rem',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          className="bonus-host-glow-text"
          style={{
            fontSize: 'clamp(1.2rem, 2.5vw, 1.8rem)',
            fontWeight: 700,
            marginBottom: '0.5rem',
          }}
        >
          {themeTitle}
        </div>
        <div
          className="bonus-host-glow-text--muted"
          style={{
            fontSize: 'clamp(0.95rem, 2vw, 1.25rem)',
            fontWeight: 500,
          }}
        >
          {t('bonus.catchMeTagline')}
        </div>
      </div>

      <div
        style={{
          padding: '1.5rem 2rem',
          backgroundColor: 'rgba(52, 211, 153, 0.12)',
          borderRadius: '20px',
          border: '4px solid rgba(52, 211, 153, 0.4)',
          display: 'inline-block',
        }}
      >
        <div
          style={{
            fontSize: 'clamp(2rem, 6vw, 4rem)',
            lineHeight: 1.4,
            letterSpacing: '0.05em',
          }}
        >
          {previewEmojis || '🐱 🐕 🐦'}
        </div>
        <div
          className="bonus-host-glow-text--muted"
          style={{
            fontSize: 'clamp(1rem, 2.8vw + 0.35rem, 1.5rem)',
            marginTop: '0.5rem',
            fontWeight: 600,
          }}
        >
          {t('bonus.player.saveAnimalsDragHint')}
        </div>
      </div>
    </div>
  );
};
